export default "__VITE_PUBLIC_ASSET__1dd635cc__"